import { blogTypes, newsTypes } from './actionTypes'
import { NewsActions, NewsState } from './types'

const initialState: NewsState = {
    news: undefined,
    article: undefined,
    relativeNews: undefined,
}

export default (state = initialState, action: NewsActions): NewsState => {
    switch (action.type) {
        case newsTypes.SET_NEWS:
            return {
                ...state,
                news: action.payload.news,
            }
        case newsTypes.SET_ONE_PIECE_OF_NEWS:
            return {
                ...state,
                article: action.payload.article,
            }

        case blogTypes.SET_RELATIVE:
            return {
                ...state,
                relativeNews: action.payload.relative,
            }
        default:
            return {
                ...state,
            }
    }
}
